import React from 'react';

import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { Redirect, Route, Switch } from 'react-router-dom';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { getReviewTemplateListRoute } from 'constants/helper';
import { routes } from 'constants/routes';

import QuestionListSidepanel from '../../common/TemplateCommons/QuestionListSidepanel';
import { QuestionListSidePanelProvider } from '../../common/TemplateCommons/QuestionListSidepanel/context/QuestionListSidepanelContext';
import ReviewTemplateForm from './ReviewTemplateForm';
import ReviewTemplatePreview from './ReviewTemplatePreview';
import { TemplateCreationSidePanelProvider } from './TemplateCreationSidepanel/TemplateCreationSidepanelContext';
import { ReviewTemplateProvider } from './common/ReviewTemplateContext';

const ReviewTemplate = () => (
  <TemplateCreationSidePanelProvider>
    <ReviewTemplateProvider>
      <QuestionListSidePanelProvider>
        <Switch>
          <Route
            exact
            path={
              checkNewNavEnabled()
                ? staticRoutesWithCustomSidebar.reviewCycleTemplateCreation
                : routes.template.review.index
            }
            component={ReviewTemplateForm}
          />
          <Route
            exact
            path={
              checkNewNavEnabled()
                ? staticRoutesWithCustomSidebar.reviewCycleTemplatePreview
                : routes.template.review.preview
            }
            component={ReviewTemplatePreview}
          />
          <Redirect to={getReviewTemplateListRoute()} />
        </Switch>
        <QuestionListSidepanel />
      </QuestionListSidePanelProvider>
    </ReviewTemplateProvider>
  </TemplateCreationSidePanelProvider>
);

export default ReviewTemplate;
